import React from "react";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

const ProfilePlaceholder = ({ size = 40, alt = "Profile", showBorder = false }) => (
  <span
    aria-label={alt}
    role="img"
    style={{
      width: size,
      height: size,
      borderRadius: "50%",
      backgroundColor: "#FFFFFF",
      border: showBorder ? "3px solid #0B65B5" : "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxSizing: "border-box",
      flexShrink: 0,
    }}
  >
    <PersonOutlineIcon
      sx={{
        color: "#0B65B5",
        fontSize: Math.round(size * 0.56),
      }}
    />
  </span>
);

export default ProfilePlaceholder;
